<div id="cms-script" class="relative sm:text-left md:text-center bg-e-white">
    <div class="cms-script-content max-w-[940px] mx-auto"></div>
</div>